// extracted by mini-css-extract-plugin
module.exports = {"form-container":"style_form-container__2_IcW"};